import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import './assets/css/reset.css'
import './assets/css/base.css'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(Vuex)
Vue.use(ElementUI);
Vue.prototype.filterAccess = function (alias){
  if(store.state.userinfo.access=='all'){
    return true
  }else if(store.state.userinfo.access_array.includes(alias)){
    return true
  }else{
    return false
  }
}
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
